module.exports = __webpack_public_path__ + "static/media/satv_color.8f1cc9f8.png";